import { Route, RouteProps, useHistory } from 'react-router-dom';
import { useEffect } from 'react';

import { Routes as ParticipantRoutes } from '../../participant/Common/useNavigation';
import { setWindowLocation } from '../../common/helpers';
import { useSession } from '../Auth/SessionProvider';
import UI from '../../common/UI';

interface GuestOnlyRouteProps extends RouteProps {
  redirectToLastProject?: boolean;
}

const GuestOnlyRoute = ({ redirectToLastProject, ...props }: GuestOnlyRouteProps) => {
  const { user } = useSession();
  const history = useHistory();

  useEffect(() => {
    // Redirect users to last (or first) project
    if (user && redirectToLastProject) {
      if (user.project_memberships.length === 0) {
        history.push('/projects/add');
        return;
      }

      const projectId = user.last_project
        ? user.last_project.id
        : user.project_memberships[0].project.id;

      history.push(`/${projectId}`);
      return;
    }

    // Redirect other logged in users.
    if (user) {
      setWindowLocation(ParticipantRoutes.Portal);
    }
  }, [user, redirectToLastProject, history]);

  // Render only for guests.
  return user
    ? <UI.PageLoader />
    : <Route {...props} />;
};

export default GuestOnlyRoute;
